export const navTitle = {'en': 'HealthVaani',
    'hi': 'हेल्थवाणी',
    'or': 'ହେଲଥବାଣୀ',
}